var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStarOutline = function SvgStarOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#star-outline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M11.049 2.927c.3-.922 1.603-.922 1.902 0L14.47 7.6a1 1 0 0 0 .95.69h4.915c.97 0 1.372 1.24.588 1.81l-3.976 2.888a1 1 0 0 0-.363 1.118l1.519 4.675c.299.92-.756 1.687-1.54 1.117l-3.975-2.888a1 1 0 0 0-1.176 0L7.436 19.9c-.783.569-1.838-.197-1.539-1.118l1.519-4.674a1 1 0 0 0-.363-1.119l-3.976-2.888c-.784-.57-.381-1.81.588-1.81h4.914a1 1 0 0 0 .951-.69z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "star-outline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgStarOutline;